/**
 * Company Search — the search input. Controlled draft text; commits the query
 * on submit (button or Enter). The committed query is what drives lookup_company
 * in the page, so keystrokes never fire a request.
 */

import { useState, type FormEvent } from "react";
import { IconSearch } from "./icons";

export function SearchBar({
  onSubmit,
  onClear,
  busy,
}: {
  onSubmit: (query: string) => void;
  onClear: () => void;
  busy: boolean;
}): JSX.Element {
  const [draft, setDraft] = useState("");

  const submit = (e: FormEvent) => {
    e.preventDefault();
    const q = draft.trim();
    if (q.length === 0) return;
    onSubmit(q);
  };

  const clear = () => {
    setDraft("");
    onClear();
  };

  return (
    <form className="sxco-searchbar" onSubmit={submit} role="search">
      <div className="sxco-search">
        <span className="sxco-search-icon" aria-hidden="true">
          <IconSearch />
        </span>
        <input
          type="text"
          className="sxco-search-input"
          placeholder="Search for a company by name…"
          aria-label="Company name"
          value={draft}
          maxLength={200}
          onChange={(e) => setDraft(e.target.value)}
        />
        {draft.length > 0 && (
          <button
            type="button"
            className="sxco-search-clear"
            aria-label="Clear search"
            onClick={clear}
          >
            ✕
          </button>
        )}
      </div>
      <button type="submit" className="sx-btn sx-btn-hero" disabled={busy || draft.trim().length === 0}>
        {busy ? "Searching…" : "Search"}
      </button>
    </form>
  );
}
